import React, { FC } from 'react';
import styles from './NavItems.module.css';

export interface NavItem {
    title: string,
    value: any,
    active: boolean,
}
interface NavItemsProps {
    items: NavItem[],
    onItemToggle: (item: NavItem) => void
}

const NavItems: FC<NavItemsProps> = ({ items, onItemToggle }) => (
    <div className={styles.NavItems} data-testid="NavItems">
        {
            items.map(item =>
                <button key={item.value} onClick={() => onItemToggle(item)} className={`${styles.navItem} ${item.active ? styles.active : ''}`}>{item.title}</button>
            )
        }
    </div>
);

export default NavItems;
